<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <div v-if="openEdit" class="space-y-8">
      <!-- Seção: Dados da Empresa -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="
              this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA
                ? 'Dados da Empresa'
                : 'Dados Institucional'
            "
            :Sessao="
              this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA
                ? 'Dados da Empresa'
                : 'Dados Institucional'
            "
            :SubSessao="
              this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA
                ? 'Dados da Empresa'
                : 'Dados Institucional'
            "
          />
        </div>
        <div class="form-section-content">
          <!-- SUB-SEÇÃO: IDENTIFICAÇÃO -->
          <div class="form-subsection">
            <h4 class="form-subsection-title">
              <i class="fa fa-building"></i>
              Identificação
            </h4>
            <div class="form-grid-12">
              <div class="col-span-5">
                <label
                  class="form-field-label form-field-label-required"
                  for="razaoSocial"
                  >Razão social</label
                >
                <input
                  class="field"
                  type="text"
                  id="razaoSocial"
                  v-model="localPJ.Nome"
                  disabled="true"
                  placeholder="Empresa X LTDA"
                />
              </div>
              <div class="col-span-4">
                <label
                  class="form-field-label form-field-label-required"
                  for="cnpj"
                  >CNPJ</label
                >
                <input
                  class="field"
                  type="text"
                  id="cnpj"
                  v-model="localPJ.Cnpj"
                  disabled="true"
                  placeholder="AA.AAA.AAA/AAAA-00"
                />
              </div>
              <div v-if="configuracaoApelido == 'S'" class="col-span-3">
                <div class="flex items-center gap-2">
                  <label
                    class="form-field-label form-field-label-required"
                    for="apelido"
                    >Apelido</label
                  >
                  <i
                    class="fa fa-info-circle form-helper-icon"
                    title="O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou minúsculas) e números. Não é permitido o uso de caracteres especiais."
                  ></i>
                </div>
                <input
                  class="field"
                  type="text"
                  id="apelido"
                  v-model="localPJ.Apelido"
                  @input="validarApelido"
                  @blur="checkApelidoLength"
                  @change="salvarAlteracoesLocalmente"
                />
                <input
                  type="hidden"
                  id="apelidoOriginal"
                  v-model="localPJ.ApelidoOriginal"
                />
                <p v-if="apelidoError" class="form-field-error">
                  {{ apelidoError }}
                </p>
                <p
                  v-if="camposObrigatorios.erroApelido"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
              <div
                v-if="
                  configuracaoAssessores === 'S' &&
                  modoPreenchimentoAssessor === '2'
                "
                class="col-span-3"
              >
                <label class="form-field-label" for="assessor">{{
                  nomeCampoAssessor
                }}</label>
                <div class="relative">
                  <div class="relative">
                    <input
                      type="text"
                      v-model="assessorBusca"
                      @input="buscarAssessores(assessorBusca)"
                      @blur="fecharDropdownAssessor"
                      :placeholder="`Selecione o ${nomeCampoAssessor}`"
                      autocomplete="off"
                      class="field"
                      :class="{ 'pr-8': assessorSelecionadoNome }"
                    />
                    <button
                      v-if="assessorSelecionadoNome"
                      type="button"
                      @mousedown.prevent="limparAssessor"
                      class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 text-lg leading-none"
                      title="Limpar"
                    >
                      ×
                    </button>
                    <span
                      v-if="assessorBuscando"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"
                      >...</span
                    >
                  </div>
                  <ul
                    v-if="assessorDropdownAberto && listaAssessores.length > 0"
                    class="assessor-dropdown"
                  >
                    <li
                      v-for="assessor in listaAssessores"
                      :key="assessor.IdExterno"
                      @mousedown.prevent="selecionarAssessor(assessor)"
                      class="assessor-dropdown-item"
                    >
                      <span class="font-medium">{{ assessor.Nome }}</span>
                      <span
                        v-if="assessor.Categoria"
                        class="text-xs opacity-60 ml-2"
                        >{{ assessor.Categoria }}</span
                      >
                    </li>
                  </ul>
                  <p
                    v-if="
                      assessorDropdownAberto &&
                      !assessorBuscando &&
                      listaAssessores.length === 0 &&
                      assessorBusca.length >= 3
                    "
                    class="text-xs text-gray-500 mt-1"
                  >
                    Nenhum {{ nomeCampoAssessor }} encontrado.
                  </p>
                </div>
              </div>
            </div>
            <div class="form-grid-2">
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="dataConstituicao"
                  >Data de constituição</label
                >
                <input
                  class="field"
                  type="field"
                  id="nome"
                  v-model="localPJ.DataConstituicaoFormatada"
                  disabled="true"
                  placeholder="00/00/0000"
                />
              </div>
              <div
                class="form-field"
                v-if="user.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA"
              >
                <label class="form-field-label" for="numeroNIRE"
                  >Número NIRE</label
                >
                <input
                  class="field"
                  type="text"
                  id="numeroNIRE"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NumeroNire"
                  placeholder=""
                />
              </div>
            </div>
            <div class="form-grid-1">
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="atividadePrincipal"
                  >Atividade principal</label
                >
                <multiselect
                  id="atividadePrincipal"
                  v-model="selectedAtividade"
                  :options="listaAtividades"
                  :custom-label="formatAtividade"
                  @change="salvarAlteracoesLocalmente"
                  label="descricao"
                  track-by="id"
                  @select="handleSelect"
                >
                </multiselect>
                <p
                  v-if="camposObrigatorios.erroAtividadePrincipal"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
            </div>
          </div>

          <div class="form-subsection-divider"></div>

          <!-- SUB-SEÇÃO: CLASSIFICAÇÃO -->
          <div class="form-subsection">
            <h4 class="form-subsection-title">
              <i class="fa fa-list-alt"></i>
              Classificação
            </h4>
            <div class="form-grid-3">
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="tipoInvestidor"
                  >Natureza Jurídica</label
                >
                <select
                  id="tipoInvestidor"
                  :disabled="localPJ.NaturezaJuridicaDataSincronizacao != null"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  v-model="localPJ.NaturezaJuridicaId"
                >
                  <option
                    v-for="item in listaNaturezaJuridica"
                    :key="item.Descricao"
                    :value="item.Codigo"
                  >
                    {{ item.Codigo }} - {{ item.Descricao.substring(0, 150) }}
                  </option>
                </select>
                <p
                  v-if="camposObrigatorios.erroNaturezaJuridica"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="tipoInvestidor"
                  >Tipo de Investidor</label
                >
                <select
                  id="tipoInvestidor"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  v-model="localPJ.TipoInvestidorId"
                >
                  <option
                    v-for="item in listaTiposInvestidores"
                    :key="item.Descricao"
                    :value="item.Id"
                  >
                    {{ item.Descricao.substring(0, 150) }}
                  </option>
                </select>
                <p
                  v-if="camposObrigatorios.erroTipoInvestidor"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="tipoCliente"
                  >Tipo do Cliente</label
                >
                <select
                  id="tipoCliente"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  v-model="localPJ.TipoClientePJId"
                >
                  <option
                    v-for="item in listaTiposClientes"
                    :key="item.Descricao"
                    :value="item.Id"
                  >
                    {{ item.Descricao }}
                  </option>
                </select>
                <p
                  v-if="camposObrigatorios.erroTipoCliente"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
            </div>
            <div class="form-grid-2">
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="formaConstituicao"
                  >Forma de Constituição</label
                >
                <select
                  class="field"
                  v-model="localPJ.FormaConstituicao"
                  @change="salvarAlteracoesLocalmente"
                >
                  <option value="">Selecione</option>
                  <option value="2">S. A.</option>
                  <option value="3">Limitada</option>
                  <option value="4">Sociedade de Capital e Indústria</option>
                  <option value="5">
                    Assoc. Civil (Ent. Soc./Clube/Igreja/Fund.)
                  </option>
                  <option value="6">Sociedade Comandita por Ações</option>
                  <option value="7">Sociedade Civil com Fins Lucrativos</option>
                  <option value="8">Sociedade em Conta Participação</option>
                  <option value="9">Cooperativa Rural/de Crédito/Habit.</option>
                  <option value="10">
                    Filial/Sucursal/Ag. Empr. Sediada no Exterior
                  </option>
                  <option value="11">Empresa Pública</option>
                </select>
                <p
                  v-if="camposObrigatorios.erroFormaConstituicao"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
              <div class="form-field">
                <div class="flex items-center gap-2">
                  <label class="form-field-label form-field-label-required"
                    >Organização sem fins lucrativos?</label
                  >
                  <i
                    class="fa fa-info-circle form-helper-icon"
                    title="Marque 'Sim' se a empresa for uma associação, fundação, ONG ou entidade sem fins lucrativos."
                  ></i>
                </div>
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      value="false"
                      :name="`SemFinsLucrativos_${index}`"
                      class="form-radio-input"
                      v-model="localPJ.SemFinsLucrativos"
                      @change="salvarAlteracoesLocalmente"
                    />
                    <span class="form-radio-label">Não</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      value="true"
                      :name="`SemFinsLucrativos_${index}`"
                      class="form-radio-input"
                      v-model="localPJ.SemFinsLucrativos"
                      @change="salvarAlteracoesLocalmente"
                    />
                    <span class="form-radio-label">Sim</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-subsection-divider"></div>

          <!-- SUB-SEÇÃO: CONTATO -->
          <div class="form-subsection">
            <h4 class="form-subsection-title">
              <i class="fa fa-phone"></i>
              Contato
            </h4>
            <div class="form-grid-3">
              <div class="form-field">
                <telefone-internacional
                  ref="telInputCelular"
                  v-model="localPJ.Telefone"
                  label="Celular"
                  name="Telefone"
                  :permitirApenascelular="true"
                  @change="salvarAlteracoesLocalmente"
                  @validate="onValidateTelefone"
                />
                <p
                  v-if="camposObrigatorios.erroTelefone"
                  class="form-field-error"
                >
                  Campo obrigatório
                </p>
              </div>
              <div v-if="configuracaoTelefone2 == 'S'" class="form-field">
                <telefone-internacional
                  v-model="localPJ.Telefone2"
                  label="Telefone Fixo"
                  name="Telefone2"
                  :opcional="true"
                  @change="salvarAlteracoesLocalmente"
                  @validate="onValidateTelefone"
                />
              </div>
              <div class="form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="emailPrincipal"
                  >E-mail da empresa</label
                >
                <input
                  class="field"
                  disabled="true"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.Email"
                  type="text"
                  id="emailPrincipal"
                />
                <p v-if="camposObrigatorios.erroEmail" class="form-field-error">
                  Campo obrigatório
                </p>
              </div>

              <div class="form-field" v-if="configuracaoEmailSecundario != 'S'">
                <label class="form-field-label" for="emailSecundario"
                  >E-mail secundário</label
                >
                <input
                  class="field"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.EmailSecundario"
                  type="text"
                  id="emailSecundario"
                  @blur="validarEmailSecundario"
                />
                <p v-if="emailErros.emailSecundario" class="form-field-error">
                  {{ emailErros.emailSecundario }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-section-divider"></div>
        </div>
      </section>
      <!-- Seção: Empresas Coligadas/Controladas -->
      <section
        class="form-section"
        v-if="user.TipoCliente == 'Pessoa Jurídica'"
      >
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Empresas coligadas, controladas ou controladoras'"
            :Sessao="'Dados da Empresa'"
            :SubSessao="'Empresas Coligadas, Controladas e Controladoras'"
          />
        </div>
        <div class="form-section-content">
          <div
            v-for="(empresa, index) in empresas"
            :key="empresa.Guid"
            class="form-repeatable-item"
          >
            <div class="form-repeatable-header">
              <div class="flex items-center justify-between w-full">
                <LabelDisclaimer
                  :TamanhoFonteLabel="'H5'"
                  :NomeLabel="`Empresa ${index + 1}`"
                />
                <button
                  @click.stop.prevent="excluirEmpresa(index)"
                  class="btn-icon-danger"
                  title="Excluir empresa"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="form-repeatable-content">
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >Tipo da empresa</label
                >
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="`tipoEmpresa_coligada_${index}`"
                      value="Coligada"
                      :name="`tipoEmpresa_${index}`"
                      class="form-radio-input"
                      v-model="empresa.Tipo"
                      @change="salvarAlteracoesLocalmenteEmpresa"
                    />
                    <span class="form-radio-label">Coligada</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="`tipoEmpresa_controlada_${index}`"
                      value="Controlada"
                      :name="`tipoEmpresa_${index}`"
                      class="form-radio-input"
                      v-model="empresa.Tipo"
                      @change="salvarAlteracoesLocalmenteEmpresa"
                    />
                    <span class="form-radio-label">Controlada</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="`tipoEmpresa_controladora_${index}`"
                      value="Controladora"
                      :name="`tipoEmpresa_${index}`"
                      class="form-radio-input"
                      v-model="empresa.Tipo"
                      @change="salvarAlteracoesLocalmenteEmpresa"
                    />
                    <span class="form-radio-label">Controladora</span>
                  </label>
                </div>
              </div>
              <div class="form-grid-2">
                <div class="form-field">
                  <label class="form-field-label form-field-label-required"
                    >Razão social</label
                  >
                  <input
                    class="field"
                    type="text"
                    @change="salvarAlteracoesLocalmenteEmpresa"
                    id="RazaoSocialTipoEmpresa"
                    v-model="empresa.RazaoSocial"
                  />
                  <p
                    v-if="
                      camposObrigatoriosEmpresa[index]?.erroRazaoSocial &&
                      tentativaPostagem
                    "
                    class="form-field-error"
                  >
                    Campo obrigatório
                  </p>
                </div>
                <div class="form-field">
                  <label class="form-field-label form-field-label-required"
                    >CNPJ</label
                  >
                  <input
                    class="field"
                    type="text"
                    @change="validarDocumentoEmpresas(index)"
                    v-mask="obterMascaraDocumentoEmpresa(index)"
                    :id="'CNPJTipoEmpresa_' + index"
                    v-model="empresa.Cnpj"
                  />
                  <p
                    v-if="
                      camposObrigatoriosEmpresa[index]?.erroCnpj &&
                      tentativaPostagem
                    "
                    class="form-field-error"
                  >
                    Campo obrigatório
                  </p>
                  <p
                    v-if="errosDocumentoEmpresa && errosDocumentoEmpresa[index]"
                    class="form-field-error"
                  >
                    {{ mensagensErroEmpresa[index] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-start">
            <button class="btn-secondary" @click="addEmpresa">
              + Adicionar empresa
            </button>
          </div>
        </div>
      </section>
      <!-- Seção: Sócios e Acionistas -->
      <section
        class="form-section"
        v-if="user.TipoCliente == 'Pessoa Jurídica'"
      >
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Sócios e Acionistas'"
            :Sessao="'Dados da Empresa'"
            :SubSessao="'Sócios e Acionistas'"
          />
          <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">
            É necessário listar os sócios e acionistas com participação maior ou
            igual a 25%.
          </p>
        </div>
        <div class="form-section-content">
          <div
            v-for="(socio, index) in socios"
            :key="socio.Guid"
            class="form-repeatable-item"
          >
            <div class="form-repeatable-header">
              <div class="flex items-center justify-between w-full">
                <LabelDisclaimer
                  :TamanhoFonteLabel="'H5'"
                  :NomeLabel="`Sócio ${index + 1}`"
                />
                <button
                  v-if="index > 0"
                  @click.stop.prevent="excluirSocio(index)"
                  class="btn-icon-danger"
                  title="Excluir sócio"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="form-repeatable-content">
              <!-- SUB-SEÇÃO: DADOS PESSOAIS -->
              <div class="form-subsection">
                <h4 class="form-subsection-title">
                  <i class="fa fa-user"></i>
                  Dados Pessoais do sócio
                </h4>
                <div class="form-grid-3">
                  <div class="form-field">
                    <InputNome
                      v-model="socio.Nome"
                      label="Nome"
                      :required="true"
                      :erro="
                        camposObrigatoriosSocio[index]?.erroNome &&
                        tentativaPostagem
                      "
                      @blur="salvarAlteracoesLocalmenteSocios"
                    />
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      :for="'TipoDocumentoSocio_' + index"
                      >Tipo de Documento</label
                    >
                    <select
                      class="field"
                      v-model="socios[index].TipoDocumento"
                      :id="'TipoDocumentoSocio_' + index"
                      @change="aoMudarTipoDocumento(index)"
                    >
                      <option value="">Selecione</option>
                      <option value="CPF">CPF</option>
                      <option value="CNPJ">CNPJ</option>
                      <option value="CNH">CNH</option>
                      <option value="RNE">RNE</option>
                      <option value="ID">ID</option>
                    </select>
                    <p
                      v-if="
                        camposObrigatoriosSocio &&
                        camposObrigatoriosSocio[index]?.erroTipoDocumento &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div
                    v-show="socios[index].TipoDocumento != ''"
                    class="form-field"
                  >
                    <label
                      class="form-field-label form-field-label-required"
                      :for="'CpfCnpjSocio_' + index"
                      >{{ obterLabelDocumento(index) }}</label
                    >
                    <input
                      class="field"
                      type="text"
                      v-model="socios[index].CpfCnpj"
                      v-mask="obterMascaraDocumento(index)"
                      :placeholder="obterPlaceholderDocumento(index)"
                      :id="'CpfCnpjSocio_' + index"
                      @change="validarDocumento(index)"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio &&
                        camposObrigatoriosSocio[index]?.erroCpfCnpj &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                    <p
                      v-if="errosDocumento && errosDocumento[index]"
                      class="form-field-error"
                    >
                      {{ mensagensErro[index] }}
                    </p>
                  </div>
                </div>
                <div class="form-grid-2">
                  <div class="form-field">
                    <telefone-internacional
                      v-model="socio.Telefone"
                      label="Telefone"
                      :name="'TelefoneSocio_' + index"
                      @validate="onValidateTelefoneSocio"
                      @change="salvarAlteracoesLocalmenteSocios"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroTelefone &&
                        !socio.Telefone
                      "
                      class="form-field-error"
                    >
                      Telefone obrigatório ou inválido
                    </p>
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      :for="'emailSocio_' + index"
                      >E-mail</label
                    >
                    <input
                      class="field"
                      type="text"
                      @change="salvarAlteracoesLocalmenteSocios"
                      v-model="socio.Email"
                      :id="'emailSocio_' + index"
                      @blur="validarEmailSocio(socio, index)"
                    />
                    <p
                      v-if="emailErros['emailSocio_' + index]"
                      class="form-field-error"
                    >
                      {{ emailErros["emailSocio_" + index] }}
                    </p>
                  </div>
                </div>
                <div class="form-grid-2">
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="porcentagemParticipacaoSocio_1"
                      >% de Participação</label
                    >
                    <input
                      class="field"
                      type="text"
                      @change="salvarAlteracoesLocalmenteSocios"
                      @blur="() => focusOutDecimal('Percentual', index)"
                      @focus="() => focusInDecimal('Percentual', index)"
                      @input="
                        (event) => handleInput(event, 'Percentual', index)
                      "
                      v-model="socio.Percentual"
                      id="porcentagemParticipacaoSocio_1"
                      placeholder="50"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroPercentual &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="form-field">
                    <label class="form-field-label form-field-label-required"
                      >Assinatura</label
                    >
                    <select
                      class="field"
                      v-model="socio.Assinatura"
                      @change="salvarAlteracoesLocalmenteSocios"
                    >
                      <option value="">Selecione</option>
                      <option value="1">Não assina pela empresa</option>
                      <option value="2">Assina isoladamente</option>
                      <option value="0">Assina em conjunto</option>
                    </select>
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroAssinatura &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </div>
              </div>

              <div class="form-subsection-divider"></div>

              <!-- SUB-SEÇÃO: ENDEREÇO -->
              <div class="form-subsection">
                <h4 class="form-subsection-title">
                  <i class="fa fa-map-marker"></i>
                  Endereço do sócio
                </h4>
                <div class="form-grid-12">
                  <div class="col-span-3 form-field">
                    <div class="flex items-center justify-between">
                      <label
                        class="form-field-label form-field-label-required"
                        for="cep"
                        >CEP</label
                      >
                      <a
                        target="_blank"
                        class="form-link text-xs"
                        href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                        >Não sei o CEP</a
                      >
                    </div>
                    <input
                      class="field"
                      type="text"
                      id="cep"
                      placeholder=""
                      v-model="socio.Cep"
                      @change="validarCep(socio)"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroCep &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="col-span-7 form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="endereco"
                      >Endereço/Logradouro</label
                    >
                    <input
                      class="field"
                      type="text"
                      :disabled="isDisabledEnderecoLogradouro"
                      id="endereco"
                      v-model="socio.Logradouro"
                      placeholder=""
                      @change="salvarAlteracoesLocalmenteSocios"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroLogradouro &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="col-span-2 form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="logradouroNumero"
                      >Número</label
                    >
                    <input
                      class="field"
                      type="text"
                      id="logradouroNumero"
                      @change="salvarAlteracoesLocalmenteSocios"
                      v-model="socio.LogradouroNumero"
                      placeholder=""
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroLogradouroNumero &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </div>
                <div class="form-grid-3">
                  <div class="form-field">
                    <label class="form-field-label" for="complemento"
                      >Complemento</label
                    >
                    <input
                      class="field"
                      type="text"
                      @change="salvarAlteracoesLocalmenteSocios"
                      v-model="socio.LogradouroComplemento"
                      id="complemento"
                      placeholder=""
                    />
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="bairro"
                      >Bairro</label
                    >
                    <input
                      class="field"
                      type="text"
                      :disabled="isDisabledEnderecoLogradouro"
                      v-model="socio.Bairro"
                      id="bairro"
                      placeholder=""
                      @change="salvarAlteracoesLocalmenteSocios"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroBairro &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="cidade"
                      >Cidade</label
                    >
                    <input
                      class="field"
                      type="text"
                      :disabled="isDisabledEndereco"
                      v-model="socio.Cidade"
                      id="cidade"
                      placeholder=""
                      @change="salvarAlteracoesLocalmenteSocios"
                    />
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroCidade &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </div>
                <div class="form-grid-2">
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="uf"
                      >UF</label
                    >
                    <select
                      class="field"
                      :disabled="isDisabledEndereco"
                      id="uf"
                      v-model="socio.Uf"
                      @change="salvarAlteracoesLocalmenteSocios"
                    >
                      <option value="null">Selecione</option>
                      <option v-for="uf in ufs" :key="uf" :value="uf">
                        {{ uf }}
                      </option>
                    </select>
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroUf &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label form-field-label-required"
                      for="Pais"
                      >País</label
                    >
                    <select
                      id="Pais"
                      @change="salvarAlteracoesLocalmenteSocios"
                      class="field"
                      v-model="socio.Pais"
                      :disabled="isDisabledEndereco"
                    >
                      <option value="">Selecione</option>
                      <option
                        v-for="item in listaPaises"
                        :key="item.Codigo"
                        :value="item.Codigo"
                      >
                        {{ item.Descricao }}
                      </option>
                    </select>
                    <p
                      v-if="camposObrigatoriosSocio[index]?.erroPais"
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </div>
              </div>

              <div class="form-subsection-divider"></div>

              <!-- SUB-SEÇÃO: INFORMAÇÕES REGULATÓRIAS -->
              <div class="form-subsection">
                <h4 class="form-subsection-title">
                  <i class="fa fa-user-shield"></i>
                  Informações Regulatórias do sócio
                </h4>
                <div class="form-grid-2">
                  <div class="form-field">
                    <label class="form-field-label form-field-label-required"
                      >É considerado US PERSON?</label
                    >
                    <div class="form-radio-group">
                      <label class="form-radio-item">
                        <input
                          type="radio"
                          value="false"
                          :name="`usPerson_${index}`"
                          class="form-radio-input"
                          v-model="socio.UsPerson"
                          @change="salvarAlteracoesLocalmenteSocios"
                        />
                        <span class="form-radio-label">Não</span>
                      </label>
                      <label class="form-radio-item">
                        <input
                          type="radio"
                          value="true"
                          :name="`usPerson_${index}`"
                          class="form-radio-input"
                          v-model="socio.UsPerson"
                          @change="salvarAlteracoesLocalmenteSocios"
                        />
                        <span class="form-radio-label">Sim</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-field">
                    <label class="form-field-label form-field-label-required"
                      >É uma Pessoa Exposta Politicamente?</label
                    >
                    <div class="form-radio-group">
                      <label class="form-radio-item">
                        <input
                          type="radio"
                          value="false"
                          :name="`pessoaExposta_${index}`"
                          class="form-radio-input"
                          v-model="socio.PoliticamenteExposta"
                          @change="salvarAlteracoesLocalmenteSocios"
                        />
                        <span class="form-radio-label">Não</span>
                      </label>
                      <label class="form-radio-item">
                        <input
                          type="radio"
                          value="true"
                          :name="`pessoaExposta_${index}`"
                          class="form-radio-input"
                          v-model="socio.PoliticamenteExposta"
                          @change="salvarAlteracoesLocalmenteSocios"
                        />
                        <span class="form-radio-label">Sim</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-subsection-divider"></div>

              <!-- SUB-SEÇÃO: INFORMAÇÕES FINANCEIRAS -->
              <div class="form-subsection">
                <h4 class="form-subsection-title">
                  <i class="fa fa-university"></i>
                  Informações Financeiras do sócio
                </h4>
                <div class="form-grid-2">
                  <div class="form-field">
                    <div class="flex items-center gap-2">
                      <label
                        class="form-field-label form-field-label-required"
                        :style="{
                          marginBottom:
                            this.nomeEmpresa == 'GENIAL' ? '0em' : '0.5rem',
                        }"
                        >RENDA MENSAL</label
                      >
                      <i
                        class="fa fa-info-circle form-helper-icon"
                        v-if="this.nomeEmpresa != 'GENIAL'"
                        title="Soma dos salários, pró-labore, honorários, pensão e/ou aposentadoria."
                      ></i>
                    </div>

                    <p
                      class="text-xs mt-1 dark:text-gray-400"
                      v-if="this.nomeEmpresa == 'GENIAL'"
                    >
                      Soma dos salários, pró-labore, honorários, pensão e/ou
                      aposentadoria.
                    </p>

                    <select
                      class="field"
                      v-model="socio.RendaMensal"
                      @change="salvarAlteracoesLocalmenteSocios"
                    >
                      <option value="">Selecione</option>
                      <option value="1">Nenhum</option>
                      <option value="2">Até R$ 5.000</option>
                      <option value="3">De R$ 5.001 até R$ 10.000</option>
                      <option value="4">De R$ 10.001 até R$ 30.000</option>
                      <option value="5">De R$ 30.001 até R$ 50.000</option>
                      <option value="6">De R$ 50.001 até R$ 100.000</option>
                      <option value="7">Acima de R$ 100.001</option>
                    </select>
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroRendaMensal &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                  <div class="form-field">
                    <div class="flex items-center gap-2">
                      <label
                        class="form-field-label form-field-label-required"
                        :style="{
                          marginBottom:
                            this.nomeEmpresa == 'GENIAL' ? '0em' : '0.5rem',
                        }"
                        >PATRIMÔNIO TOTAL</label
                      >
                      <i
                        v-if="this.nomeEmpresa != 'GENIAL'"
                        class="fa fa-info-circle form-helper-icon"
                        title="Soma da situação patrimonial."
                      ></i>
                    </div>

                    <p
                      class="text-xs mt-1 dark:text-gray-400"
                      v-if="this.nomeEmpresa == 'GENIAL'"
                    >
                      Soma da situação patrimonial.
                    </p>

                    <select
                      class="field"
                      v-model="socio.PatrimonioTotal"
                      @change="salvarAlteracoesLocalmenteSocios"
                    >
                      <option value="">Selecione</option>
                      <option value="1">Nenhum</option>
                      <option value="2">Até R$ 5.000</option>
                      <option value="3">De R$ 5.001 até R$ 10.000</option>
                      <option value="4">De R$ 10.001 até R$ 30.000</option>
                      <option value="5">De R$ 30.001 até R$ 50.000</option>
                      <option value="6">De R$ 50.001 até R$ 100.000</option>
                      <option value="7">Acima de R$ 100.001</option>
                    </select>
                    <p
                      v-if="
                        camposObrigatoriosSocio[index]?.erroPatrimonioTotal &&
                        tentativaPostagem
                      "
                      class="form-field-error"
                    >
                      Campo obrigatório
                    </p>
                  </div>
                </div>
                <div class="form-grid-2">
                  <div class="form-field">
                    <div class="flex items-center gap-2">
                      <label
                        class="form-field-label"
                        for="outrosRendimentos"
                        :style="{
                          marginBottom:
                            this.nomeEmpresa == 'GENIAL' ? '0em' : '0.5rem',
                        }"
                        >Outros Rendimentos - Anual (R$)</label
                      >
                      <i
                        v-if="this.nomeEmpresa != 'GENIAL'"
                        class="fa fa-info-circle form-helper-icon"
                        title="Bonificações, dividendos, juros, etc."
                      ></i>
                    </div>

                    <p
                      class="text-xs mt-1 dark:text-gray-400"
                      v-if="this.nomeEmpresa == 'GENIAL'"
                    >
                      Bonificações, dividendos, juros, etc.
                    </p>

                    <input
                      class="field"
                      v-model="socio.OutrosRendimentos"
                      type="text"
                      id="nome"
                      @change="salvarAlteracoesLocalmenteSocios"
                      @blur="() => focusOutCurrency('OutrosRendimentos', index)"
                      @focus="() => focusInCurrency('OutrosRendimentos', index)"
                      @input="
                        (event) =>
                          handleInput(event, 'OutrosRendimentos', index)
                      "
                    />
                  </div>
                  <div class="form-field">
                    <label
                      class="form-field-label"
                      for="outrosRendimentosOrigem"
                      :style="{
                        marginBottom:
                          this.nomeEmpresa == 'GENIAL' ? '1.1em' : '0.5rem',
                      }"
                      >Especifique a origem dos outros rendimentos</label
                    >
                    <input
                      class="field"
                      type="text"
                      @change="salvarAlteracoesLocalmenteSocios"
                      v-model="socio.OutrosRendimentosOrigem"
                      id="outrosRendimentosOrigem"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-start pb-8">
            <button class="btn-secondary" @click="addSocio">
              + Adicionar outro sócio/acionista
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>

  <ModalAlerta
    :mostrar="modalAlerta.mostrar"
    :tipo="modalAlerta.tipo"
    :titulo="modalAlerta.titulo"
    :mensagem="modalAlerta.mensagem"
    @fechar="fecharModalAlerta"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@/api/axios";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";
import Multiselect from "vue-multiselect";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import { mask } from "vue-the-mask";
import documentoUtils from "@/utils/documentoUtils";
import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

import {
  formatDecimal,
  parseDecimal,
  formatCurrency,
  parseCurrency,
  handleInput,
  validarCampoCep,
  ufs,
} from "@/utils/formUtils";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
export default {
  name: "CadastroPF_DadosEmpresa",
  props: ["Edicao"],
  emits: ["valid-salvar"],
  mixins: [emailValidatorMixin],
  directives: {
    mask,
  },
  components: {
    LabelDisclaimer,
    Multiselect,
    ModalAlerta,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      infoEmpresa: "GET_PJ_INFO_EMPRESA",
      infoComplementoEmpresa: "GET_PJ_INFO_COMPLEMENTO_EMPRESA",
      infoComplementoSocios: "GET_PJ_INFO_COMPLEMENTO_SOCIOS",
      empresasComplemento: "GET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA",
      sociosComplemento: "GET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS",
      listaAtividades: "GET_LISTA_ATIVIDADES",
      listaTiposInvestidores: "GET_LISTA_TIPOS_INVESTIDORES",
      listaNaturezaJuridica: "GET_LISTA_NATUREZA_JURIDICA",
      listaTiposClientes: "GET_LISTA_TIPOS_CLIENTES_PJ",
      salvarInformacoesPJ: "GET_PJ_SALVAR_INFO",
      getConfiguracoes: "GET_CONFIGURACOES",
      listaPaises: "GET_LISTA_PAISES",
    }),
    existeSocioCriticoAlterado() {
      return this.socios.some((s) => {
        const key = s.Guid;
        const orig = this.originalSociosByKey[key];
        return this._changedCriticalFields(s, orig);
      });
    },
    labelDocumento() {
      // Retorna uma função que recebe o índice e verifica se o socio existe
      return (index) => {
        // Verifica se socio e socio[index] existem antes de acessar TipoDocumento
        if (!this.socios || !this.socios[index]) return "CPF/CNPJ/Outros";
        return documentoUtils.obterLabelDocumento(
          this.socios[index].TipoDocumento || "CPF",
        );
      };
    },
    mascaraDocumento() {
      // Retorna uma função que recebe o índice e verifica se o socio existe
      return (index) => {
        // Verifica se socio e socio[index] existem antes de acessar TipoDocumento
        if (!this.socios || !this.socios[index]) return "###.###.###-##";
        return documentoUtils.obterMascaraDocumento(
          this.socios[index].TipoDocumento || "CPF",
        );
      };
    },
    placeholderDocumento() {
      // Retorna uma função que recebe o índice e verifica se o socio existe
      return (index) => {
        // Verifica se socio e socio[index] existem antes de acessar TipoDocumento
        if (!this.socios || !this.socios[index]) return "000.000.000-00";
        return documentoUtils.obterPlaceholderDocumento(
          this.socios[index].TipoDocumento || "CPF",
        );
      };
    },
    selectedAtividade: {
      get() {
        return (
          this.listaAtividades.find(
            (atividade) => atividade.id === this.localPJ.AtividadePrincipal,
          ) || null
        );
      },
      set(value) {
        this.localPJ.AtividadePrincipal = value ? value.id : null;
      },
    },
    ufs() {
      return ufs;
    },
  },
  data() {
    return {
      TIPO_CLIENTE,
      habilitarCampoAssessor: false,
      configuracaoAssessores: "",
      modoPreenchimentoAssessor: "",
      assessorBusca: "",
      assessorSelecionadoNome: "",
      listaAssessores: [],
      assessorDropdownAberto: false,
      assessorBuscando: false,
      assessorBuscaTimer: null,
      nomeCampoAssessor: "Assessor",
      originalSociosByKey: {},
      permitirAvancar: false,
      validando: false,
      openEdit: false,
      tentativaPostagem: false,
      emailErros: {},
      errosDocumento: {},
      mensagensErro: {},
      errosDocumentoEmpresa: {},
      mensagensErroEmpresa: {},
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      camposObrigatorios: {
        erroApelido: false,
        erroDataConstituicao: false,
        erroAtividadePrincipal: false,
        erroTipoInvestidor: false,
        erroNaturezaJuridica: false,
        erroTipoCliente: false,
        erroTelefone: false,
        erroTelefone2: false,
        erroEmail: false,
        erroFormaConstituicao: false,
      },
      camposObrigatoriosEmpresa: [],
      camposObrigatoriosSocio: [],
      localPJ: {
        Nome: null,
        Cnpj: null,
        Apelido: null,
        ApelidoOriginal: null,
        AtividadePrincipal: null,
        TipoInvestidorId: null,
        NaturezaJuridicaId: null,
        NaturezaJuridicaDataSincronizacao: null,
        TipoClientePJId: null,
        DataConstituicao: null,
        Email: null,
        EmailSecundario: null,
        FormaConstituicao: null,
        NumeroNire: null,
        OutrosDescricao: null,
        Telefone: null,
        Telefone2: null,
        SemFinsLucrativos: false,
        AssessorId: null,
      },
      empresas: [],
      novaEmpresa: {
        Guid: "",
        RazaoSocial: "",
        Cnpj: "",
        Tipo: "",
      },
      socios: [
        {
          Guid: "",
          Nome: "",
          Email: "",
          Percentual: "",
          CpfCnpj: "",
          TipoDocumento: "CPF",
          UsPerson: false,
          PoliticamenteExposta: false,
          Assinatura: "",
          Logradouro: "",
          LogradouroNumero: "",
          LogradouroComplemento: "",
          Telefone: "",
          Bairro: "",
          Cidade: "",
          Cep: "",
          Pais: "",
          Uf: "",
          RendaMensal: "",
          PatrimonioTotal: "",
          OutrosRendimentos: "",
          OutrosRendimentosOrigem: "",
        },
      ],
      novoSocio: {
        Guid: "",
        Nome: "",
        Email: "",
        Percentual: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        UsPerson: false,
        PoliticamenteExposta: false,
        Assinatura: "",
        Logradouro: "",
        LogradouroNumero: "",
        LogradouroComplemento: "",
        Bairro: "",
        Cidade: "",
        Cep: "",
        Pais: "",
        Uf: "",
        RendaMensal: "",
        PatrimonioTotal: "",
        OutrosRendimentos: "",
        OutrosRendimentosOrigem: "",
      },
      email: "",
      mensagemErro: "",
      apelidoError: "",
      nomeEmpresa: "",
      isDisabledEndereco: false,
      isDisabledEnderecoLogradouro: false,
      configuracaoTelefone2: "",
      configuracaoApelido: "",
      telefoneValido: [],
      telefoneSocioValido: [],
    };
  },
  methods: {
    _normalize(v) {
      return v == null ? "" : String(v).trim();
    },
    _changedCriticalFields(curr, orig) {
      if (!orig && curr.Assinatura != 1) return true;

      if (!orig && curr.Assinatura == 1) return false;

      const nome = this._normalize(curr.Nome);
      const cpf = this._normalize(curr.CpfCnpj);

      const assinatura =
        curr.Assinatura == null ? "" : String(curr.Assinatura).trim();
      const assinaturaOrig =
        orig.Assinatura == null ? "" : String(orig.Assinatura).trim();

      const email = this._normalize(curr.Email).toLowerCase();

      return (
        nome !== this._normalize(orig.Nome) ||
        cpf !== this._normalize(orig.CpfCnpj) ||
        assinatura !== assinaturaOrig ||
        email !== this._normalize(orig.Email).toLowerCase()
      );
    },
    _makeKey(s, i = 0) {
      const guid = (s.Guid || "").trim();
      if (guid) return guid;

      const cpf = (s.CpfCnpj || "").trim();
      const email = (s.Email || "").toLowerCase().trim();
      if (cpf || email) return `${cpf}|${email}`;

      return `tmp-${Date.now()}-${i}`; // evita colisões para itens novos
    },
    setOriginalSocios(list) {
      this.originalSociosByKey = {};
      list.forEach((s, i) => {
        const key = this._makeKey(s, i);
        // garante que o objeto carregue sua própria key para reuso
        if (this.$set) this.$set(s, "_key", key);
        else s._key = key;

        this.originalSociosByKey[key] = {
          Nome: (s.Nome || "").trim(),
          CpfCnpj: (s.CpfCnpj || "").trim(),
          Assinatura: s.Assinatura == null ? "" : String(s.Assinatura).trim(), // "0"|"1"|"2"
          Email: (s.Email || "").toLowerCase().trim(),
        };
      });
    },
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        if (!(name == "Telefone2" && this.localPJ.Telefone2.length < 4)) {
          this.telefoneValido[name] = valid;
        }
      }
    },
    verificarOutros() {
      if (!this.localPJ.OutrosDescricao) {
        this.localPJ.OutrosDescricao = "";
      }
    },
    fecharModalAlerta() {
      this.modalAlerta.mostrar = false;
    },
    onValidateTelefoneSocio({ name, valid }) {
      if (!this.telefoneSocioValido) {
        this.telefoneSocioValido = {};
      }
      if (valid != "undefined") {
        this.telefoneSocioValido[name] = valid;
      }
    },
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    // Métodos para obter propriedades de documento
    obterLabelDocumento(index) {
      // Verifica se o array e o item no índice existem
      if (!this.socios || !this.socios[index]) return "CPF/CNPJ";

      // Verifica se o item tem TipoDocumento definido
      const tipo = this.socios[index].TipoDocumento || "CPF";
      return documentoUtils.obterLabelDocumento(tipo);
    },

    validarDocumentoEmpresas(index) {
      if (!this.empresas || !this.empresas[index]) return;

      if (this.empresas[index].Cnpj) {
        const resultado = documentoUtils.validarDocumentoCompleto(
          this.empresas[index].Cnpj,
          "CNPJ",
        );
        this.errosDocumentoEmpresa[index] = !resultado.valido;
        this.mensagensErroEmpresa[index] = resultado.mensagem;

        if (!resultado.valido && this.empresas[index].Cnpj != "") {
          this.$nextTick(() => {
            const inputElement = document.getElementById(
              "CNPJTipoEmpresa_" + index,
            );
            if (inputElement) {
              inputElement.focus();
            }
          });
        }
      } else {
        this.errosDocumentoEmpresa[index] = false;
        this.mensagensErroEmpresa[index] = "";
      }

      this.salvarAlteracoesLocalmenteEmpresa();
    },

    validarDocumento(index) {
      if (!this.socios || !this.socios[index]) return;

      if (this.socios[index].CpfCnpj) {
        const resultado = documentoUtils.validarDocumentoCompleto(
          this.socios[index].CpfCnpj,
          this.socios[index].TipoDocumento || "CPF",
        );
        this.errosDocumento[index] = !resultado.valido;
        this.mensagensErro[index] = resultado.mensagem;

        if (!resultado.valido && this.socios[index].CpfCnpj != "") {
          this.$nextTick(() => {
            const inputElement = document.getElementById(
              "CpfCnpjSocio_" + index,
            );
            if (inputElement) {
              inputElement.focus();
            }
          });
        }
      } else {
        this.errosDocumento[index] = false;
        this.mensagensErro[index] = "";
      }

      this.salvarAlteracoesLocalmenteSocios();
    },

    obterMascaraDocumento(index) {
      // Verifica se o array e o item no índice existem
      if (!this.socios || !this.socios[index]) return "###.###.###-##";

      // Verifica se o item tem TipoDocumento definido
      const tipo = this.socios[index].TipoDocumento || "CPF";
      return documentoUtils.obterMascaraDocumento(tipo);
    },

    obterMascaraDocumentoEmpresa() {
      return documentoUtils.obterMascaraDocumento("CNPJ");
    },

    aoMudarTipoDocumento(index) {
      if (!this.socios || !this.socios[index]) return;

      this.validarDocumento(index);

      this.salvarAlteracoesLocalmenteSocios();
    },

    obterPlaceholderDocumento(index) {
      // Verifica se o array e o item no índice existem
      if (!this.socios || !this.socios[index]) return "000.000.000-00";

      // Verifica se o item tem TipoDocumento definido
      const tipo = this.socios[index].TipoDocumento || "CPF";
      return documentoUtils.obterPlaceholderDocumento(tipo);
    },
    getOptionValue(index) {
      return index + 1;
    },
    focusOutCurrency(fieldName, index) {
      this.socios[index][fieldName] = formatCurrency(
        this.socios[index][fieldName],
      );
    },
    focusInCurrency(fieldName, index) {
      const value = this.socios[index][fieldName];
      this.socios[index][fieldName] = parseCurrency(value)
        ? parseCurrency(value).replace(".", ",")
        : "";
    },
    focusOutDecimal(fieldName, index) {
      this.socios[index][fieldName] = formatDecimal(
        this.socios[index][fieldName],
      );
    },
    focusInDecimal(fieldName, index) {
      const value = this.socios[index][fieldName];
      this.socios[index][fieldName] = parseDecimal(value)
        ? parseDecimal(value).replace(".", ",")
        : "";
    },
    handleInput(event, fieldName, index) {
      const inputValue = event.target.value;
      this.socios[index][fieldName] = handleInput(inputValue);
    },
    converterData(dataString) {
      if (dataString && dataString !== "0001-01-01T00:00:00") {
        let data = new Date(dataString);
        let ano = data.getFullYear();
        let mes = (data.getMonth() + 1).toString().padStart(2, "0"); // adiciona um 0 à esquerda se for de 1 a 9
        let dia = data.getDate().toString().padStart(2, "0");
        return `${ano}-${mes}-${dia}`; // retorna a data no formato 'YYYY-MM-DD'
      } else {
        return null;
      }
    },
    validarApelido(event) {
      if (this.configuracaoApelido === "S") {
        const value = event.target.value;
        const regex = /[^a-zA-Z0-9]/g;
        this.localPJ.Apelido = value.replace(regex, "").slice(0, 20);
      }
    },
    checkApelidoLength(event) {
      if (
        (!this.localPJ.Apelido || this.localPJ.Apelido.length < 3) &&
        this.nomeEmpresa != "GENIAL"
      ) {
        this.apelidoError =
          "O campo apelido deve ter no mínimo três caracteres.";
        event.target.focus();
      } else {
        this.apelidoError = "";
      }
    },
    formatAtividade({ descricao }) {
      return descricao;
    },
    handleSelect(selecionado) {
      this.atualizarAtividadePrincipal(selecionado);
      this.salvarAlteracoesLocalmente();
    },
    atualizarAtividadePrincipal(selecionado) {
      this.localPJ.AtividadePrincipal = selecionado ? selecionado.id : null;
      this.salvarAlteracoesLocalmente();
    },
    async proximaEtapa() {
      if (this.validando) return;

      this.validando = true;
      try {
        if (this.validarFormulario(true)) {
          // Definir flags ANTES de salvar para evitar notificação
          this.$store.commit("SET_ETAPA_CADASTRO", 1);
          this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);

          await this.salvarInformacoes();
        }
      } finally {
        this.validando = false;
      }
    },
    validarEmailSocio(socio, index) {
      const fieldId = "emailSocio_" + index;

      this.validarEmailGeneric(socio.Email, fieldId, {
        obrigatorio: true,
        mensagemObrigatorio: "Campo obrigatório.",
      });
    },
    validarEmailSecundario() {
      // eslint-disable-next-line no-debugger
      this.validarEmailGeneric(
        this.localPJ.EmailSecundario,
        "emailSecundario",
        {
          obrigatorio: false,
          emailComparacao: this.localPJ.Email,
          mensagemEmailsIguais:
            "O e-mail secundário não pode ser igual ao e-mail da empresa.",
        },
      );
    },
    validarFormulario(submeter) {
      this.permitirAvancar = true;
      this.tentativaPostagem = submeter;
      var nomeDoCampo = "";
      var valorInvalido = false;
      this.camposObrigatorios = {
        erroApelido: false,
        erroDataConstituicao: false,
        erroAtividadePrincipal: false,
        erroTipoInvestidor: false,
        erroNaturezaJuridica: false,
        erroTipoCliente: false,
        erroTelefone: false,
        erroTelefone2: false,
        erroEmail: false,
        erroFormaConstituicao: false,
      };
      // Verificar se há algum erro no objeto emailErros
      if (Object.values(this.emailErros).some((erro) => erro !== "")) {
        nomeDoCampo = "E-mail";
        this.permitirAvancar = false;
      }

      if (!this.localPJ.Apelido && this.configuracaoApelido === "S") {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroApelido = true;
          nomeDoCampo = "Apelido";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.AtividadePrincipal) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroAtividadePrincipal = true;
          nomeDoCampo = "Atividade Principal";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.TipoInvestidorId) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTipoInvestidor = true;
          nomeDoCampo = "Tipo de Investidor";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.NaturezaJuridicaId) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroNaturezaJuridica = true;
          nomeDoCampo = "Natureza Jurídica";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.TipoClientePJId) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTipoCliente = true;
          nomeDoCampo = "Tipo do Cliente";
        }
        this.permitirAvancar = false;
      }

      this.$refs.telInputCelular?.validate();

      if (!this.localPJ.Telefone || this.telefoneValido.Telefone == false) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTelefone = true;
          nomeDoCampo = "Celular";
        }
        if (this.telefoneValido.Telefone == false) {
          valorInvalido = true;
        }
        this.permitirAvancar = false;
      }

      if (
        this.configuracaoTelefone2 === "S" &&
        this.localPJ?.Telefone2 &&
        this.localPJ.Telefone2.length > 4 &&
        (!this.localPJ.Telefone2 || this.telefoneValido.Telefone2 == false)
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTelefone2 = true;
          nomeDoCampo = "Telefone Fixo";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.Email) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEmail = true;
          nomeDoCampo = "E-mail da empresa";
        }
        this.permitirAvancar = false;
      }
      if (!this.localPJ.FormaConstituicao) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroFormaConstituicao = true;
          nomeDoCampo = "Forma de Constituição";
        }
        this.permitirAvancar = false;
      }
      var somaPercentual = 0;
      if (this.user.TipoCliente != TIPO_CLIENTE.INSTITUCIONAL) {
        for (let index = 0; index < this.empresas.length; index++) {
          const obj = this.empresas[index];
          if (!obj.RazaoSocial) {
            this.camposObrigatoriosEmpresa[index].erroRazaoSocial = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Razão social da Empresa Coligada/Controlada/Controladora ${
                index + 1
              }`;
            break;
          } else {
            this.camposObrigatoriosEmpresa[index].erroRazaoSocial = false;
          }
          if (!obj.Cnpj) {
            this.camposObrigatoriosEmpresa[index].erroCnpj = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `CPF/CNPJ da Empresa Coligada/Controlada/Controladora ${
                index + 1
              }`;
            break;
          } else {
            this.camposObrigatoriosEmpresa[index].erroCnpj = false;
          }

          if (
            this.mensagensErroEmpresa[index] != null &&
            this.mensagensErroEmpresa[index] != ""
          ) {
            this.permitirAvancar = false;
          }
        }

        for (let index = 0; index < this.socios.length; index++) {
          const obj = this.socios[index];
          somaPercentual += parseInt(obj.Percentual);
          if (!obj.Nome) {
            this.camposObrigatoriosSocio[index].erroNome = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Nome do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroNome = false;
          }

          if (!obj.TipoDocumento) {
            this.camposObrigatoriosSocio[index].erroTipoDocumento = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Tipo de documento do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroTipoDocumento = false;
          }

          const resultado = documentoUtils.validarDocumentoCompleto(
            this.socios[index].CpfCnpj,
            this.socios[index].TipoDocumento || "CPF",
          );

          if (!resultado.valido && nomeDoCampo === "") {
            valorInvalido = true;
            nomeDoCampo = `Documento do Sócio/Acionista ${index + 1}`;
            this.permitirAvancar = false;

            this.errosDocumento[index] = !resultado.valido;
            this.mensagensErro[index] = resultado.mensagem;

            if (!resultado.valido && this.socios[index].CpfCnpj != "") {
              this.$nextTick(() => {
                const inputElement = document.getElementById(
                  "CpfCnpjSocio_" + index,
                );
                if (inputElement) {
                  inputElement.focus();
                }
              });
            }

            break;
          }

          if (!obj.CpfCnpj) {
            this.camposObrigatoriosSocio[index].erroCpfCnpj = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `CPF/CNPJ do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroCpfCnpj = false;
          }

          if (
            this.mensagemErro[index] != null &&
            this.mensagemErro[index] != ""
          ) {
            this.permitirAvancar = false;
          }

          const telefoneValido =
            this.telefoneSocioValido[`TelefoneSocio_${index}`];

          if (
            !obj.Telefone ||
            telefoneValido === false ||
            obj.Telefone?.length < 5
          ) {
            this.camposObrigatoriosSocio[index].erroTelefone = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Telefone do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroTelefone = false;
          }
          if (!obj.Email) {
            this.camposObrigatoriosSocio[index].erroEmail = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `E-mail do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroEmail = false;
          }
          if (!obj.Percentual) {
            this.camposObrigatoriosSocio[index].erroPercentual = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Percentual do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroPercentual = false;
          }
          if (!obj.Cep) {
            this.camposObrigatoriosSocio[index].erroCep = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `CEP do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroCep = false;
          }
          if (!obj.Logradouro && this.isDisabledEnderecoLogradouro === false) {
            this.camposObrigatoriosSocio[index].erroLogradouro = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Endereço/Logradouro do Sócio/Acionista ${
                index + 1
              }`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroLogradouro = false;
          }
          if (!obj.LogradouroNumero) {
            this.camposObrigatoriosSocio[index].erroLogradouroNumero = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Número do logradouro do Sócio/Acionista ${
                index + 1
              }`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroLogradouroNumero = false;
          }
          if (!obj.Bairro && this.isDisabledEnderecoLogradouro === false) {
            this.camposObrigatoriosSocio[index].erroBairro = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Bairro do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroBairro = false;
          }
          if (!obj.Cidade && this.isDisabledEndereco === false) {
            this.camposObrigatoriosSocio[index].erroCidade = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Cidade do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroCidade = false;
          }
          if (!obj.Uf && this.isDisabledEndereco === false) {
            this.camposObrigatoriosSocio[index].erroUf = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `UF do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroUf = false;
          }
          if (!obj.Pais && this.isDisabledEndereco === false) {
            this.camposObrigatoriosSocio[index].erroPais = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Pais do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroPais = false;
          }
          if (
            obj.Assinatura === null ||
            obj.Assinatura === undefined ||
            obj.Assinatura === ""
          ) {
            this.camposObrigatoriosSocio[index].erroAssinatura = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Assinatura do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroAssinatura = false;
          }
          if (
            obj.RendaMensal === null ||
            obj.RendaMensal === undefined ||
            obj.RendaMensal === ""
          ) {
            this.camposObrigatoriosSocio[index].erroRendaMensal = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo = `Renda Mensal do Sócio/Acionista ${index + 1}`;
            }
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroRendaMensal = false;
          }
          if (
            obj.PatrimonioTotal === null ||
            obj.PatrimonioTotal === undefined ||
            obj.PatrimonioTotal === ""
          ) {
            this.camposObrigatoriosSocio[index].erroPatrimonioTotal = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = `Patrimônio Total do Sócio/Acionista ${index + 1}`;
            break;
          } else {
            this.camposObrigatoriosSocio[index].erroPatrimonioTotal = false;
          }
        }
        if (somaPercentual > 100) {
          this.permitirAvancar = false;
          this.modalAlerta = {
            mostrar: true,
            tipo: "error",
            titulo: "Atenção!",
            mensagem:
              "A soma dos percentuais dos sócios não pode ultrapassar 100%. Verifique os valores informados.",
          };
        }
      }
      if (submeter && nomeDoCampo != "") {
        const mensagem = valorInvalido
          ? `O campo ${nomeDoCampo} foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`
          : `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`;

        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem: mensagem,
        };
      }

      return this.permitirAvancar;
    },
    async salvarInformacoes() {
      this.validarFormulario(true);

      if (this.permitirAvancar) {
        if (
          this.socios.length > 0 &&
          (this.socios.some((a) => a.Guid == null) ||
            this.existeSocioCriticoAlterado)
        ) {
          var documentoAtivo = await verificarDocumentoAtivo();

          if (documentoAtivo) {
            var confirmado = await confirmarReassinatura();
            if (!confirmado) {
              return;
            }
          }
        }

        this.validarApelido({ target: { value: this.localPJ.Apelido } });
        if (this.apelidoError) {
          return false;
        }
        this.$store.commit("SET_PJ_SALVAR_INFO", true);
      }
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit("SET_PJ_SALVAR_INFO_EMPRESA", this.localPJ);
      this.validarFormulario();
    },
    salvarAlteracoesLocalmenteEmpresa() {
      this.$store.commit(
        "SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA",
        this.empresas,
      );
      this.validarFormulario();
    },
    salvarAlteracoesLocalmenteSocios() {
      var sociosFormat = this.socios.map((socio) => {
        let socioCopy = { ...socio };
        if (socioCopy.Percentual) {
          socioCopy.Percentual = socioCopy.Percentual.replaceAll(".", "")
            .replaceAll(",", ".")
            .trim();
        }
        if (socioCopy.OutrosRendimentos) {
          socioCopy.OutrosRendimentos = socioCopy.OutrosRendimentos.replace(
            "R$",
            "",
          )
            .replaceAll(".", "")
            .replaceAll(",", ".")
            .trim();
        }
        return socioCopy;
      });

      this.$store.commit("SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS", sociosFormat);
      this.validarFormulario();
    },
    addEmpresa() {
      this.novaEmpresa = {
        Guid: "",
        RazaoSocial: "",
        Cnpj: "",
        Tipo: "Coligada",
      };
      this.empresas.push({ ...this.novaEmpresa });
      if (!this.camposObrigatoriosEmrpesa) this.camposObrigatoriosEmrpesa = [];
      this.camposObrigatoriosEmrpesa.push({
        erroerroRazaoSocial: false,
        erroCnpj: false,
      });
    },
    addSocio() {
      this.novoSocio = {
        Guid: "",
        Nome: "",
        Email: "",
        Percentual: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        UsPerson: false,
        PoliticamenteExposta: false,
        Assinatura: "",
        Logradouro: "",
        LogradouroNumero: "",
        LogradouroComplemento: "",
        Bairro: "",
        Cidade: "",
        Cep: "",
        Pais: "",
        Uf: "",
        RendaMensal: "",
        PatrimonioTotal: "",
        OutrosRendimentos: 0,
        OutrosRendimentosOrigem: "",
      };
      this.socios.push({ ...this.novoSocio });
      if (!this.camposObrigatoriosSocio) this.camposObrigatoriosSocio = [];
      this.camposObrigatoriosSocio.push({
        erroNome: false,
        erroCpfCnpj: false,
        erroEmail: false,
        erroPercentual: false,
        erroAssinatura: false,
        erroCep: false,
        erroTipoDocumento: false,
        erroLogradouro: false,
        erroLogradouroNumero: false,
        erroBairro: false,
        erroCidade: false,
        erroUf: false,
        erroPais: false,
        erroRendaMensal: false,
        erroPatrimonioTotal: false,
      });
    },
    async excluirEmpresa(index) {
      this.disableBtn = true;

      if (this.empresas[index].Guid == "") {
        this.empresas.splice(index, 1);
        return;
      }
      this.salvarAlteracoesLocalmenteEmpresa();
      await api
        .get(
          `PessoaJuridica/empresas/excluir?guid=${this.empresas[index].Guid}`,
        )
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$swal({
              icon: "success",
              title: "Exclusão realizada com sucesso!",
              text: "Dados informados foram excluídos com sucesso.",
            });
            this.empresas.splice(index, 1);
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos.",
            text: `${error.response.data.data[0]}`,
          });
        });
    },
    async excluirSocio(index) {
      this.disableBtn = true;

      if (this.socios[index].Guid == "") {
        this.socios.splice(index, 1);
        this.setOriginalSocios(this.socios);
        return;
      }

      if (this.socios[index].Assinatura != "1") {
        var documentoAtivo = await verificarDocumentoAtivo();
        if (documentoAtivo) {
          var confirmado = await confirmarReassinatura();
          if (!confirmado) {
            return;
          }
        }
      }

      await api
        .get(`PessoaJuridica/socios/excluir?guid=${this.socios[index].Guid}`)
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$swal({
              icon: "success",
              title: "Exclusão realizada com sucesso!",
              text: "Dados informados foram excluídos com sucesso.",
            });
            this.socios.splice(index, 1);
            this.setOriginalSocios(this.socios);
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos.",
            text: `${error.response.data.data[0]}`,
          });
        });
    },
    validarEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    focarCampoEmail() {
      const input = document.getElementById("emailSecundario");
      if (input) {
        input.focus();
      }
    },
    validateDecimal(event, index) {
      if (this.socios[index]) {
        let value = event.target.value;

        // Remove caracteres não numéricos, exceto a vírgula
        value = value.replace(/[^0-9,]/g, "");

        // Garantir que apenas uma vírgula seja permitida
        const parts = value.split(",");
        if (parts.length > 2) {
          value = parts[0] + "," + parts.slice(1).join("");
        }

        // Limitar a dois dígitos após a vírgula
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + "," + parts[1].slice(0, 2);
        }

        event.target.value = value;
        this.socios[index].Percentual = value;
      }
    },
    async buscarAssessores(termo) {
      clearTimeout(this.assessorBuscaTimer);
      this.localPJ.AssessorId = null;
      this.assessorSelecionadoNome = "";
      if (!termo || termo.length < 3) {
        this.listaAssessores = [];
        this.assessorDropdownAberto = false;
        return;
      }
      this.assessorBuscaTimer = setTimeout(async () => {
        try {
          this.assessorBuscando = true;
          const res = await api.get(
            `/assessor?nomeAssessor=${encodeURIComponent(termo)}`,
          );
          this.listaAssessores = res.data || [];
          this.assessorDropdownAberto = true;
        } catch {
          this.listaAssessores = [];
        } finally {
          this.assessorBuscando = false;
        }
      }, 400);
    },
    selecionarAssessor(assessor) {
      this.localPJ.AssessorId = assessor.IdExterno;
      this.assessorSelecionadoNome = assessor.Nome;
      this.assessorBusca = assessor.Nome;
      this.assessorDropdownAberto = false;
      this.listaAssessores = [];
      this.salvarAlteracoesLocalmente();
    },
    limparAssessor() {
      this.localPJ.AssessorId = null;
      this.assessorSelecionadoNome = "";
      this.assessorBusca = "";
      this.listaAssessores = [];
      this.assessorDropdownAberto = false;
      this.salvarAlteracoesLocalmente();
    },
    fecharDropdownAssessor() {
      setTimeout(() => {
        this.assessorDropdownAberto = false;
      }, 150);
    },
    inicializarCamposObrigatoriosSocio() {
      this.camposObrigatoriosSocio = this.socios.map(() => ({
        erroNome: false,
        erroCpfCnpj: false,
        erroEmail: false,
        erroPercentual: false,
        erroTipoDocumento: false,
        erroAssinatura: false,
        erroCep: false,
        erroLogradouro: false,
        erroLogradouroNumero: false,
        erroBairro: false,
        erroCidade: false,
        erroUf: false,
        erroPais: false,
        erroRendaMensal: false,
        erroPatrimonioTotal: false,
      }));
    },
    inicializarCamposObrigatoriosEmpresa() {
      this.camposObrigatoriosEmpresa = this.empresas.map(() => ({
        erroRazaoSocial: false,
        erroCnpj: false,
      }));
    },
    async validarCep(objDados, somenteValidar = false) {
      if (objDados.Cep) {
        var result = await validarCampoCep(objDados, {
          somenteValidar: somenteValidar,
        });
        if (result) {
          this.isDisabledEndereco = true;
          this.isDisabledEnderecoLogradouro = true;
          if (objDados.Logradouro == "") {
            this.isDisabledEnderecoLogradouro = false;
          }
        } else {
          this.isDisabledEndereco = false;
          this.isDisabledEnderecoLogradouro = false;
        }
      }
    },
  },
  async created() {
    //this.socios = [];
    if (
      this.socios[0] == null &&
      this.user.TipoCliente != TIPO_CLIENTE.INSTITUCIONAL
    ) {
      this.addSocio();
    }
    await this.fetchConfiguracao([
      "EXIBIR TELEFONE 2",
      "Exibir apelido",
      "Ocultar e-mail secundário",
      "Assessores - Ativo",
      "Habilitar campo assessor",
      "Nome do Assessor",
    ]);
    this.configuracaoTelefone2 = await this.getConfiguracoes(
      "EXIBIR TELEFONE 2",
    ).Valor;
    this.configuracaoApelido = await this.getConfiguracoes("Exibir apelido")
      .Valor;
    this.configuracaoEmailSecundario = await this.getConfiguracoes(
      "Ocultar e-mail secundário",
    )?.Valor;
    this.configuracaoAssessores =
      this.getConfiguracoes("Assessores - Ativo")?.Valor ?? "";
    this.modoPreenchimentoAssessor =
      this.getConfiguracoes("Habilitar campo assessor")?.Valor ?? "";
    this.nomeCampoAssessor =
      this.getConfiguracoes("Nome do Assessor")?.Valor || "Assessor";
  },
  mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.socios = [];
    this.localPJ = this.infoEmpresa;
    //Socios
    if (
      this.infoComplementoSocios != null &&
      this.infoComplementoSocios.length > 0
    ) {
      var sociosFormat2 = this.infoComplementoSocios.map((socio) => {
        if (socio.Percentual) {
          socio.Percentual = formatDecimal(
            socio.Percentual.toString().replaceAll(".", ","),
          );
        }

        if (socio.OutrosRendimentos) {
          socio.OutrosRendimentos = formatCurrency(
            socio.OutrosRendimentos.toString().replaceAll(".", ","),
          );
        }
        return socio;
      });
      this.socios = sociosFormat2;
      this.setOriginalSocios(this.socios);
    } else if (this.socios[0] == null || this.socios == []) {
      if (this.user.TipoCliente != TIPO_CLIENTE.INSTITUCIONAL) this.addSocio();
    }

    this.localPJ.Nome = this.user?.NomeRazaoSocial;
    this.inicializarCamposObrigatoriosSocio();
    this.inicializarCamposObrigatoriosEmpresa();
    this.validarFormulario();

    this.openEdit = true;
  },
  watch: {
    infoEmpresa() {
      this.localPJ = this.infoEmpresa;
      if (
        this.infoEmpresa != null &&
        this.infoEmpresa.DataConstituicao != null
      ) {
        this.localPJ.DataConstituicao = this.converterData(
          this.infoEmpresa.DataConstituicao,
        );
      }
      this.localPJ.Nome = this.user?.NomeRazaoSocial;
    },
    infoComplementoEmpresa: {
      handler() {
        if (this.infoComplementoEmpresa != null) {
          this.empresas = this.infoComplementoEmpresa;
        }
      },
      immediate: true
    },
    infoComplementoSocios() {
      if (this.infoComplementoSocios && this.infoComplementoSocios.length > 0) {
        var sociosFormat = this.infoComplementoSocios.map((socio) => {
          if (socio.Percentual) {
            socio.Percentual = formatDecimal(
              socio.Percentual.toString().replaceAll(".", ","),
            );
          }
          if (socio.OutrosRendimentos) {
            socio.OutrosRendimentos = formatCurrency(
              socio.OutrosRendimentos.toString().replaceAll(".", ","),
            );
          }
          return socio;
        });

        this.socios = sociosFormat;
        this.setOriginalSocios(this.socios);
      }
    },
    socios: {
      handler(newSocios) {
        this.camposObrigatoriosSocio = newSocios.map(() => ({
          erroNome: false,
          erroCpfCnpj: false,
          erroEmail: false,
          erroPercentual: false,
          erroTipoDocumento: false,
          erroAssinatura: false,
          erroCep: false,
          erroLogradouro: false,
          erroLogradouroNumero: false,
          erroBairro: false,
          erroCidade: false,
          erroUf: false,
          erroPais: false,
          erroRendaMensal: false,
          erroPatrimonioTotal: false,
        }));
        newSocios.forEach((socio) => {
          if (socio.cep) {
            this.validarCep(socio, true);
          }
          this.$watch(
            () => socio.cep,
            (newCep) => {
              if (newCep) {
                this.validarCep(socio, true);
              }
            },
          );
        });
      },
      deep: true,
      immediate: true,
    },
    empresas: {
      handler(newEmpresas) {
        this.camposObrigatoriosEmpresa = newEmpresas.map(() => ({
          erroRazaoSocial: false,
          erroCnpj: false,
        }));
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

.field__radio {
  margin-top: -2px;
  width: 20px;
  height: 20px;
}

.assessor-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 50;
  margin-top: 2px;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 0.25rem;
  background: white;
  border: 1px solid #d0d5dd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  margin-left: 0;
  padding: 0.25rem 0;
}

.assessor-dropdown-item {
  padding: 0.6rem 0.875rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #344054;
  transition: background 0.15s;
  display: flex;
  align-items: baseline;
}

.assessor-dropdown-item:hover {
  background: #f2f4f7;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
